import { cva } from "class-variance-authority";

/**
 * Every button in the product comes from here.
 * Colours, radius and focus ring are brand tokens (see resources/css/app.css),
 * so changing the palette or the radius changes every button at once.
 *
 * variant:
 *   default     filled brand — one per view
 *   secondary   brand outline — the companion action
 *   quiet       neutral outline — toolbars, cards, tables
 *   ghost       no chrome — dismissive actions
 *   live        Bindle Live violet — only ever on a Bindle Live action
 *   destructive irreversible actions
 *   link        inline text action
 */
export const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md font-semibold " +
    "transition-[background-color,border-color,color,box-shadow] duration-150 cursor-pointer " +
    "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring " +
    "disabled:pointer-events-none disabled:opacity-45 " +
    "[&_svg]:pointer-events-none [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-brand text-brand-contrast hover:bg-brand-hover border border-transparent",
        secondary: "border border-brand text-brand-soft-text bg-transparent hover:bg-brand-soft",
        quiet: "border border-line bg-surface text-ink hover:bg-surface-2",
        ghost: "border border-transparent text-muted hover:bg-surface-2 hover:text-ink",
        live: "bg-live text-white hover:bg-live/90 border border-transparent",
        destructive: "bg-danger text-white hover:opacity-90 border border-transparent",
        outline: "border border-line bg-surface text-ink hover:bg-surface-2",
        link: "text-brand underline-offset-4 hover:underline border-0 px-0",
      },
      size: {
        default: "h-11 px-5 text-[15px]",
        sm: "h-9 px-3.5 text-sm rounded-sm",
        lg: "h-13 px-6.5 text-base",
        icon: "h-11 w-11 p-0",
        "icon-sm": "h-9 w-9 p-0 rounded-sm",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);
